import InfoModal from '@sdk/components/ui/InfoModal/InfoModal';
import BrandLoader from '@sdk/components/ui/BrandLoader';
import Row from '@sdk/components/ui/spacing/Row';
import { DismissButton } from '@sdk/components/ui/InfoModal/infoInnerModal.styles';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import gettext from '@sdk/lang/gettext';
import ProgressButton from '@sdk/components/ui/buttons/ProgressButton';

import { ShiftTaskDashboardNotification } from '@web/shiftTasks/types/ShiftTaskDashboardNotification';
import { ShiftTaskInstanceModalInner } from '@web/shiftTasks/ShiftTaskInstanceModalInner/ShiftTaskInstanceModalInner';
import { ShiftTaskNotificationHeader } from '@web/shiftTasks/ShiftTaskNotificationModal/ShiftTaskNotificationHeader/ShiftTaskNotificationHeader';

import {
  useShiftTaskNotification,
  useShiftTaskNotificationActions,
} from './shiftTaskNotificationModal.hooks';

type Props = {
  notification: ShiftTaskDashboardNotification;
  onClose: VoidFunction;
};

export const ShiftTaskNotificationModal = ({ notification, onClose }: Props) => {
  const { headerProps, shiftTask, isLoading } = useShiftTaskNotification({
    notification,
    onClose,
  });
  const { canCompleteTask, completeTask } = useShiftTaskNotificationActions(shiftTask);

  if (!isLoading && !shiftTask) {
    return null;
  }

  return (
    <InfoModal
      bodyPadding={0}
      fullScreen
      header={<ShiftTaskNotificationHeader onClose={onClose} {...headerProps} />}
      zIndex={1045}
      dismiss={onClose}
      buttons={
        <Row>
          <DismissButton onClick={onClose}>{gettext('Close')}</DismissButton>
          {canCompleteTask && (
            <DismissButton
              as={ProgressButton}
              buttonType={ButtonType.success}
              onClick={completeTask}
              inactive={isLoading}>
              {gettext('Complete')}
            </DismissButton>
          )}
        </Row>
      }>
      {isLoading ? (
        <Row justifyContent="center">
          <BrandLoader />
        </Row>
      ) : (
        <ShiftTaskInstanceModalInner shiftTask={shiftTask} />
      )}
    </InfoModal>
  );
};
